import EmailSent from './EmailSent'

export default EmailSent



// WEBPACK FOOTER //
// ./src/containers/account/EmailSent/index.js